import React from "react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";

interface LogoutConfirmationDialogProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

export const LogoutConfirmationDialog: React.FC<
	LogoutConfirmationDialogProps
> = ({ open, onClose, onConfirm }) => {
	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle>Confirm Logout</DialogTitle>
			<DialogContent>
				<DialogContentText>
					Are you sure you want to logout?
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<Button onClick={onConfirm} color="primary">
					Logout
				</Button>
			</DialogActions>
		</Dialog>
	);
};
